/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=b39d4862&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=b39d4862&lang=less&scoped=true"

import exportComponent from "E:\\202601_code\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39d4862"]])

export default __exports__